'use strict';

var toastMessageHelper = require('./toastMessageHelper');

/**
 * Initialize datepicker with holiday filtering for ear piercing appointments.
 * This function sets up the datepicker on page load with:
 *  - Common holidays that apply to all stores
 *  - Store-specific holidays that are dynamically loaded based on selected store
 *  - Date format: dd/mm/yyyy
 *  - Start date restricted to today
 *  - Week starts on Monday
 *
 * @param {string} storeHolidays - Optional JSON string containing store-specific holidays
 * @returns {void}
 */
function initializeEarPiercingDatepicker(storeHolidays) {
    var $dateInput = $('#ckc-earpiercing-appointment-date, #ckc-astral-appointment-date, #ckc-jewelry-appointment-date, #ckc-pickup-appointment-date');
    if (!$dateInput.length) {
        return;
    }

    var holidaysData = storeHolidays || $('#commonandstoreHolidays, #ShowroomHolidays, #astroholidays, #vintageCarpagedateHolidays, #ShowroomHolidays, #storePickupDropHolidays').val();
    var allHolidayData = {};
    try {
        allHolidayData = holidaysData ? JSON.parse(holidaysData) : {};
    } catch (e) {
        toastMessageHelper.showNotification('Error parsing holiday data:', e);
    }

    // Convert holidays array directly to holidaysSet object
    var holidaysSet = {};
    if (allHolidayData && Array.isArray(allHolidayData)) {
        allHolidayData.forEach(function (date) {
            holidaysSet[date] = true;
        });
    }

    /**
     * Get holidays for currently selected store.
     * Combines common holidays with store-specific holidays.
     * @returns {Object} Object with holiday dates as keys (format: DD/MM/YYYY)
     */
    var getHolidaysForSelectedStore = function () {
        var holidays = [];

        if (allHolidayData && allHolidayData.commonHolidays && Array.isArray(allHolidayData.commonHolidays)) {
            holidays = holidays.concat(allHolidayData.commonHolidays);
        }

        var selectedStoreId = $('.storedata .store-container input[name="storeOption"]:checked').val()
            || $('.storedata .store-container.checked').find('input[type="radio"]').val()
            || $('#astral-selectedpage-container .storedata .store-container.checked input[type="radio"]').val()
            || $('#astralstorepage-container .storedata .store-container.checked input[type="radio"]').val();

        if (selectedStoreId && allHolidayData.showroomHolidays && Array.isArray(allHolidayData.showroomHolidays)) {
            var selectedStoreHolidays = allHolidayData.showroomHolidays.find(function (store) {
                return store.storeId === selectedStoreId;
            });

            if (selectedStoreHolidays && selectedStoreHolidays.holidays && Array.isArray(selectedStoreHolidays.holidays)) {
                holidays = holidays.concat(selectedStoreHolidays.holidays);
            }
        }

        holidaysSet = {};
        holidays.forEach(function (date) {
            holidaysSet[date] = true;
        });

        return holidaysSet;
    };

    $.fn.datepicker.dates.en.daysMin = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    $dateInput
        .datepicker('destroy')
        .datepicker({
            format: 'dd/mm/yyyy',
            language: 'en',
            autoclose: true,
            todayHighlight: false,
            startDate: '+0d',
            container: '.datepicker-container',
            weekStart: 1,
            maxViewMode: 2,
            beforeShowDay: function (date) {
                // Use getHolidaysForSelectedStore only if holidaysSet is empty
                if (Object.keys(holidaysSet).length === 0) {
                    holidaysSet = getHolidaysForSelectedStore();
                }

                // Format date to DD/MM/YYYY to match holiday format
                var day = ('0' + date.getDate()).slice(-2);
                var month = ('0' + (date.getMonth() + 1)).slice(-2);
                var year = date.getFullYear();
                var dateString = day + '/' + month + '/' + year;

                // Disable the date if it's a holiday
                var isHoliday = holidaysSet[dateString] === true;
                return !isHoliday;
            }
        })
        .on('show', function (e) {
            e.stopPropagation();
            $('.table-condensed .prev').text('');
            $('.table-condensed .next').text('');
        })
        .on('changeDate', function (e) {
            if (e.date) {
                var day = ('0' + e.date.getDate()).slice(-2);
                var month = ('0' + (e.date.getMonth() + 1)).slice(-2);
                var year = e.date.getFullYear();
                var formattedDate = day + '/' + month + '/' + year;
                $(this).val(formattedDate);
            }
        });

    $dateInput.on('click', function () {
        $('.table-condensed .prev').text('');
        $('.table-condensed .next').text('');
    });
}

/**
 * Loads available pickup slots for a given store via AJAX and updates the DOM.
 *
 * Sends a GET request to the 'TryAtShowRoom-GetSlots' endpoint with the store ID.
 * On success:
 *   1. Replaces the HTML content of #pickupSlots with the returned HTML.
 *   2. Iterates over all elements with class `.pick-selected-value` and sets
 *      their text to the value of their `data-alttext` attribute (or empty string).
 *
 * @param {string|number} storeId - The ID of the store to fetch pickup slots for.
 * @returns {void}
 */
function loadSlots(storeId) {
    $.ajax({
        url: 'TryAtShowRoom-GetTimeSlots',
        method: 'GET',
        data: {
            storeID: storeId
        },
        success: function (html) {
            $('#earpiercingtimeslot, #astraltimeslot').html(html);
            $('.piercing-selected-value, .astral-selected-value').each(function () {
                var $this = $(this);
                var altText = $this.data('alttext');
                $this.text(altText || '');
            });
        }
    });
}

/**
 * Validates a guest checkout field using contextual rules (name, email, phone, or generic required checks).
 * @param {JQuery} $field - The input/select element wrapped in jQuery whose value should be validated.
 * @returns {boolean} True when the field value complies with its rules; otherwise false with feedback applied.
 */
function validateField($field) {
    var value = $field.val();
    var isValid = true;
    var errorMsg = '';
    var $errorDiv;
    var fieldId = $field.attr('id');
    var isNameField = fieldId === 'firstName' || fieldId === 'lastName';
    var isEmailField = $field.attr('type') === 'email';
    var isPhoneField = $field.attr('type') === 'tel' || fieldId === 'phone';
    var isPostalCodeField = fieldId === 'pincode';
    var isCityField = fieldId === 'city';
    var isAddressField = fieldId === 'Address1';
    var isLanguagePreferenceField = fieldId === 'languagepreference';
    var isOptionalAttributeField = fieldId === 'optionalattribute';
    var isTermsAcceptedField = fieldId === 'termsAccepted';

    if (isNameField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var pattern = /^[A-Za-z][A-Za-z\s]*$/;
        if (isValid && value && !pattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('invalid-error');
        }
    } else if (isEmailField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9@._-]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var emailPattern = /^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (isValid && value && !emailPattern.test(value)) {
            isValid = false;
            errorMsg = $field.data('pattern-mismatch') || 'Please enter a valid email address';
        }
    } else if (isPhoneField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);
        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }

        var requiredLength = parseInt($field.attr('data-phonelength'), 10)
            || parseInt($field.attr('maxlength'), 10)
            || 10;

        var countryCode = $field.attr('data-countrycode');

        if (countryCode === '+91' && value.length > 0) {
            if (!/^[6-9]/.test(value)) {
                $field.val('');
                value = '';
                isValid = false;
                errorMsg = $field.data('format-error');
            }
        }

        if (isValid && value.length !== requiredLength) {
            isValid = false;
            errorMsg = 'Please enter valid phone number';
        }
    } else if (isPostalCodeField) {
        let cleanedValue = value.replace(/[^0-9]/g, '');
        if (cleanedValue !== value) {
            $field.val(cleanedValue);
        }
        value = cleanedValue;
        if (cleanedValue.length > 6) cleanedValue = cleanedValue.substring(0, 6);
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        } else if (value && value.length !== 6) {
            isValid = false;
            errorMsg = 'please enter the valid input';
        }
    } else if (isCityField) {
        let cleanedValue = value.replace(/[^A-Za-z\s]/g, '').replace(/^\s+/, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue;

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value.trim()) {
            isValid = false;
            errorMsg = $field.data('missing-error') || 'City is required';
        }
    } else if (isAddressField) {
        let cleanedValue = value.replace(/[^A-Za-z0-9\s,.\-/]/g, '');
        if (cleanedValue !== value) $field.val(cleanedValue);

        value = cleanedValue.trim();

        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }
    } else if (isTermsAcceptedField) {
        if (!$field.prop('checked')) {
            isValid = false;
            errorMsg = $field.data('missing-error');
        }
    } else {
        value = value.trim();
        if (($field.prop('required') || $field.closest('.form-group').hasClass('required')) && !value) {
            if (!isOptionalAttributeField) {
                isValid = false;
                errorMsg = $field.data('missing-error');
            }
        }
    }

    $errorDiv = $field.siblings('.invalid-feedback');

    if (!isValid) {
        $field.addClass('is-invalid');
        $errorDiv.text(errorMsg).show();
    } else {
        $field.removeClass('is-invalid');
        $errorDiv.text('').hide();
    }

    if (isLanguagePreferenceField) {
        if ($field.hasClass('is-invalid')) {
            $('.language-preference-dropdown .custom-drop-down').addClass('is-invalid');
        } else {
            $('.language-preference-dropdown .custom-drop-down').removeClass('is-invalid');
        }
    }

    return isValid;
}

/**
 * Populates city/state fields by reverse geocoding the supplied pincode for a shipping/billing block.
 * @param {string} idPrefix - Full field prefix (for example `guestShipping`) used to target related inputs.
 * @param {string} pincode - Postal code entered by the shopper.
 * @param {string} country - Country code tied to the postal lookup.
 */
function fetchPlace(idPrefix, pincode, country) {
    var googleApiKey = $('#google-maps-api-key').val();
    var apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + pincode + ',' + country + '&key=' + googleApiKey;

    $.getJSON(apiUrl, function (data) {
        var citySelector = idPrefix ? '#' + idPrefix + 'City' : '#city';
        var stateSelector = idPrefix ? '#' + idPrefix + 'State' : '#state';
        $(citySelector).val('');
        $(stateSelector).val('');

        if (data.status === 'OK' && data.results.length) {
            var result = data.results[0];
            var city = '';
            var state = '';

            result.address_components.forEach(function (component) {
                if (component.types.includes('locality')) {
                    city = component.long_name;
                }
                if (component.types.includes('administrative_area_level_1')) {
                    state = component.long_name;
                }
            });

            if (city) $(citySelector).val(city).trigger('input');
            if (state) $(stateSelector).val(state).trigger('input');
        }
    });
}

module.exports = {
    initializeEarPiercingDatepicker: initializeEarPiercingDatepicker,
    loadSlots: loadSlots,
    validateField: validateField,
    fetchPlace: fetchPlace
};
